import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  setCustomLayer,
  setSearchCustomLayer,
  updateProperties,
} from '../../store/actions';
import MenuCloseButton from './MenuCloseButton';

export class SpatialSearchMenuComponent extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    const layerName = event.target.value;
    const layer = this.props.layers.filter(l => l.title === layerName)[0];

    if (layerName === '') {
      this.props.reset();
    } else {
      this.props.handleChangeSearch(layer);
    }

    this.props.onCloseClick();
  }

  render() {
    const {
      offsetLeft,
      onCloseClick,
      layers,
      previouslySearchedLayer,
    } = this.props;
    const filteredLayers = (layers || []).filter(l => l.limitToOutline
      && l.limitToOutline === true);

    return (
      <div className="map-toolbar__menu map-toolbar--demographics" style={{ left: offsetLeft }}>
        <MenuCloseButton onCloseClick={onCloseClick} />
        <div className="toolbox-content filter-box">
          <h4>Choose Spatial Layer:</h4>
          <form>
            { filteredLayers.map(layerOption => (
              <div className="map-toolbar__option" key={layerOption.title}>
                <input
                  type="radio"
                  className="radio--custom"
                  id={layerOption.title}
                  name={layerOption.title}
                  value={layerOption.title}
                  checked={previouslySearchedLayer.title === layerOption.title}
                  onChange={this.handleChange}
                />
                <label htmlFor={layerOption.title}>{layerOption.title}</label>
              </div>
            ))}

          </form>
        </div>
      </div>
    );
  }
}

SpatialSearchMenuComponent.propTypes = {
  layers: PropTypes.arrayOf(PropTypes.object).isRequired,
  reset: PropTypes.func,
  offsetLeft: PropTypes.number,
  onCloseClick: PropTypes.func.isRequired,
  handleChangeSearch: PropTypes.func.isRequired,
  previouslySearchedLayer: PropTypes.object.isRequired,
};

/* istanbul ignore next */
export const mapStateToProps = (state, { type }) => {
  return {
    filters: state[type].filters,
    sort: state[type].sort,
    organizationId: state.organizationId,
    previouslySearchedLayer: state.saveSearchedLayers,
  };
};

/* istanbul ignore next */
export const mapDispatchToProps = (dispatch, { type }) => {
  return {
    handleChangeSearch: (filters, sort, organizationId) => layer => {
      const updatedFilters = new Map([...filters, ['shapefile', layer]]);

      // included because onSubmitClick does the same...
      // and in redux devtools it ALWAYS readjusts "sort"
      updatedFilters.delete('sort');

      // submits form
      dispatch(updateProperties(
        type,
        updatedFilters,
        sort,
        organizationId,
      ));
    },
    reset: () => {
      dispatch(setCustomLayer(type, []));
      dispatch(setSearchCustomLayer({}));
    },
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { filters, sort, organizationId, previouslySearchedLayer } = stateProps;
  const { handleChangeSearch } = dispatchProps;
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    handleChangeSearch: handleChangeSearch(filters, sort, organizationId, previouslySearchedLayer),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SpatialSearchMenuComponent);



// WEBPACK FOOTER //
// ./src/components/MapToolbar/SpatialSearchMenu.js